import { render, staticRenderFns } from "./LocationCheckInSettings.vue?vue&type=template&id=0bfc536e&"
import script from "./LocationCheckInSettings.vue?vue&type=script&lang=js&"
export * from "./LocationCheckInSettings.vue?vue&type=script&lang=js&"
import style0 from "./LocationCheckInSettings.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports